import { useSuspenseQuery } from "@tanstack/react-query";
import api from "apis";
import { GetDocumentsByCategoryParams } from "apis/data-contracts";

const useMyDeskDocumentsQuery = (options: GetDocumentsByCategoryParams) => {
  return useSuspenseQuery({
    queryKey: api.document.getDocumentsByCategoryKey(options),
    queryFn: () => api.document.getDocumentsByCategory(options),
  });
};

export default useMyDeskDocumentsQuery;
